import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActiveLicense = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 19,
			r: 18,
			stroke: "#BCA4FF",
			strokeDasharray: "7 7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 19,
			r: 14,
			fill: "#8E68F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 15.6668V22.3335C25 24.3335 24 25.6668 21.6667 25.6668H16.3333C14 25.6668 13 24.3335 13 22.3335V15.6668C13 13.6668 14 12.3335 16.3333 12.3335H21.6667C24 12.3335 25 13.6668 25 15.6668Z",
			stroke: "white",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.668 14V15.3333C20.668 16.0667 21.268 16.6667 22.0013 16.6667H23.3346",
			stroke: "white",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.332 19.6665H18.9987",
			stroke: "white",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.332 22.3335H21.6654",
			stroke: "white",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgActiveLicense;
